<template>
    <svg>
        <use :href="`#${icon}`" />
    </svg>
</template>

<script setup lang="ts">
defineProps<{
    icon: string;
}>();
</script>
